import { Badge, Tabs } from 'antd';
import { ButtonCommon } from '..';
import { Info, Plus, ShoppingCart } from '@phosphor-icons/react';
import { CartStatus } from 'types/common';
import { CartTabProps } from 'types/ProductType';
import { useMemo } from 'react';

const CartTab: React.FC<CartTabProps> = ({
  activeCartId,
  carts,
  activeCart,
  handleChangeCart,
  handleAddNewCart,
  isDesktop,
}) => {
  // Memoize tab items to prevent recreating them on every render
  const tabItems = useMemo(() => {
    return carts.map((cart) => {
      const isActive = cart.id === activeCartId;
      const isProductSelection = cart.status === CartStatus.PRODUCT_SELECTION;

      // Determine tab styling based on status
      const bgColor = isActive
        ? isProductSelection
          ? 'bg-[var(--primaryColor500)]'
          : 'bg-[var(--sematicSuccessColor500)]'
        : 'bg-[var(--textBlack4)]';

      // Determine text color based on status
      const textColor = isActive
        ? 'text-white'
        : isProductSelection
          ? 'text-[var(--primaryColor500)]'
          : 'text-[var(--sematicSuccessColor500)]';

      // Determine icon color
      const iconColor = isActive
        ? 'text-white'
        : isProductSelection
          ? 'text-[var(--primaryColor500)]'
          : 'text-[var(--sematicSuccessColor)]';

      return {
        key: cart.id,
        label: (
          <div className={`flex items-center gap-2 p-3 px-4 w-full h-[48px] rounded-lg ${bgColor}`}>
            <Badge size='small'>
              {isProductSelection ? (
                <ShoppingCart size={18} weight='regular' className={iconColor} />
              ) : (
                <Info size={18} weight='regular' className={iconColor} />
              )}
            </Badge>
            <span className={`text-md font-medium ${textColor}`}>{cart.name}</span>
          </div>
        ),
      };
    });
  }, [carts, activeCartId, activeCart?.status]);

  // Memoize the add new cart button
  const addNewCartButton = useMemo(() => {
    if (carts.length >= 3 && !isDesktop) return null;

    return (
      <ButtonCommon
        onClick={handleAddNewCart}
        icon={<Plus size={16} />}
        color='soft'
        radius='rounded'
        className='!h-[48px] ml-4 !text-[var(--primaryColor500)]'
        isDisabled={carts.length >= 3}
      >
        Thêm giỏ mới
      </ButtonCommon>
    );
  }, [carts.length, isDesktop, handleAddNewCart]);

  return (
    <Tabs
      activeKey={activeCartId || undefined}
      onChange={handleChangeCart}
      tabBarExtraContent={{
        right: addNewCartButton,
      }}
      items={tabItems}
      type='card'
      className='cart-tabs'
    />
  );
};

export default CartTab;
